import React from 'react';
import loadable from '@loadable/component';
import { graphql, useStaticQuery } from 'gatsby';
import { BoldSkeleton } from '@bold/web-components-react';

import ArrowUp from 'assets/images/global/svg/ic_chevron_right_w.inline.svg';

import Slider from 'components/website/Home/OldHome/Slider';
import SiteAlert from 'components/SiteAlert';
import SegmentButton from 'components/website/SegmentButton';
import Hero from './Hero';

const Terminals = loadable(() => import('./Terminals'), {
  fallback: <BoldSkeleton height="400px" />,
});
const HeroOne = loadable(() => import('components/website/BoldAccount/Hero/HeroOne'), {
  fallback: <BoldSkeleton height="400px" />,
});
const Benefits = loadable(() => import('./Benefits'), {
  fallback: <BoldSkeleton height="400px" />,
});
const Community = loadable(() => import('./Community'), {
  fallback: <BoldSkeleton height="400px" />,
});
const BoldStore = loadable(() => import('./BoldStore'), {
  fallback: <BoldSkeleton height="400px" />,
});
const Portal = loadable(() => import('components/Portal'));

const NewHome = ({ withSlide }) => {
  const { allContentfulBoldHomePage } = useStaticQuery(graphql`
    query HomeData {
      allContentfulBoldHomePage {
        nodes {
          heroDesktop {
            gatsbyImageData(layout: FULL_WIDTH, quality: 90, outputPixelDensities: 1.5)
          }
          heroMobile {
            gatsbyImageData(layout: FULL_WIDTH, quality: 90, outputPixelDensities: 1.5)
          }
          heroTablet {
            gatsbyImageData(layout: FULL_WIDTH, quality: 90, outputPixelDensities: 1.5)
          }
          hideDataphones
          title
          showRibbonNewBadge
          ribbonMessage
          ribbonLink
          isBlank
          appBoldGallery {
            gatsbyImageData(layout: CONSTRAINED, quality: 90)
          }
          appBoldVideo {
            file {
              url
            }
          }
          communityVideo {
            category
            id
            nameOfTheBusiness
            nameOfTheEntrepreneur
            video {
              file {
                url
              }
            }
            post {
              slug
            }
            poster {
              file {
                url
              }
            }
          }
          boldStoreCarousel {
            gatsbyImageData(layout: CONSTRAINED, quality: 90)
          }
        }
      }
    }
  `);

  const {
    heroDesktop,
    heroMobile,
    heroTablet,
    hideDataphones,
    showRibbonNewBadge,
    ribbonMessage,
    ribbonLink,
    isBlank,
    communityVideo,
    appBoldGallery,
    boldStoreCarousel,
    appBoldVideo,
  } = allContentfulBoldHomePage.nodes[0];

  return (
    <div style={{ overflow: 'hidden' }}>
      {withSlide && <Slider />}
      <div className="home-container pages-container">
        {!withSlide && <Hero {...{ heroDesktop, heroMobile, heroTablet, hideDataphones }} />}
        <Portal idSelector="site-alerts">
          <SegmentButton
            event="button"
            url={ribbonLink}
            isBlank={isBlank}
            isLink
            obj={{
              page_section: 'ribbon alert',
            }}
          >
            <SiteAlert className="head-alert head-alert-one">
              {showRibbonNewBadge && <span className="alert-badge">NUEVO</span>}
              <span dangerouslySetInnerHTML={{ __html: ribbonMessage }} />
              <div>
                <ArrowUp />
              </div>
            </SiteAlert>
          </SegmentButton>
        </Portal>
        <section id="home-ribbon" className="home-ribbon">
          <SegmentButton
            event="button"
            url={ribbonLink}
            isBlank={isBlank}
            isLink
            obj={{
              page_section: 'ribbon alert',
            }}
          >
            <SiteAlert className="body-alert">
              {showRibbonNewBadge && <span className="alert-badge">NUEVO</span>}
              <span dangerouslySetInnerHTML={{ __html: ribbonMessage }} />
              <div>
                <ArrowUp />
              </div>
            </SiteAlert>
          </SegmentButton>
        </section>
        <Terminals />
        <HeroOne isHome section="cuenta_bold" />
        <Benefits {...{ appBoldGallery, appBoldVideo }} />
        <Community {...{ communityVideo }} />
        <Portal idSelector="home-store">
          <BoldStore {...{ boldStoreCarousel }} />
        </Portal>
      </div>
    </div>
  );
};

export default NewHome;
